
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AkkhorLayout from "../layout/akkhor";
import { URL_LIST_ALL } from "../configs/api";
import { useSelector } from "react-redux";
import Axios from "axios";
import men_teacher from "../assets/img/men-teacher.png"
import { Modal, Pagination } from "react-bootstrap";
import Moment from "react-moment";

export default function DanhSachProfile() {
    const { user } = useSelector((state) => state.auth);
    const [params, setParam] = useState('');
    const [fullname, setFullname] = useState();
    const [filterShow, setFilterShow] = useState(false)
    const [listProfile, setListProfile] = useState([])
    const [show, setShow] = useState(false)
    const [modalInfo, setModalInfo] = useState(null)

    const handleSubmit = (e) => {
        e.preventDefault();
        let _param = ''
        if (fullname !== '') _param += "&fullname=" + fullname
        setParam(_param);
    };


    useEffect(
        function () {
            let mounted = true;
            Axios.get(URL_LIST_ALL + "learninghub_profiles", user.config)
                .then(async (res) => {
                    if (res.data.status === "success") {
                        if (mounted) {
                            setListProfile(res.data.data);
                        }
                    } else console.log(res.data.message);
                })
                .catch((err) => console.log(err));
            return () => (mounted = false);

        }, [user]
    );

    const linkify = (html) =>
        html.replace(
            /(?<!src="|href="|">)(https?:\/\/[^\s<]+)/g,
            '<a href="$1" class="text-danger" target="_blank" rel="noopener noreferrer">$1</a>'
        );


    return (<AkkhorLayout idrole="learninghub-profile">
        <div className="breadcrumbs-area">
            <ul>
                <li>
                    <Link to="/">Trang chủ</Link>
                </li>
                <li>
                    Profile giảng viên
                </li>
            </ul>
        </div>
        <div className="card card-filter mb-3">
            <div className="card-header">
                <div className="d-flex" onClick={() => setFilterShow(!filterShow)}>
                    <div className="mr-auto">
                        <h3 className="title">Tìm kiếm</h3>
                    </div>
                    <button className="btn btn-sm btn-defaul" onClick={() => setFilterShow(!filterShow)}><span className={!filterShow ? "fas fa-angle-down" : "fas fa-angle-up"}></span></button>
                </div>
            </div>
            <div className={filterShow ? "card-body" : 'hidden-filter'}>
                <form className="new-added-form" method="get" >
                    <div className="row">
                        <div className="col-lg-3 col-md-6 col-sm-6 col-12 form-group">
                            <label>Họ tên</label>
                            <input type="text" placeholder="Họ tên" value={fullname} onChange={(e) => setFullname(e.target.value)} className="form-control height32" autoComplete="off" />
                        </div>
                        <div className="col-12 ">
                            <button type="submit" onClick={handleSubmit} className="btn-fill-sm btn-gradient-yellow btn-hover-bluedark">Lọc</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <div className="w-100 list-profile">
            <div className="row">
                <h3 className="col-12 text-center mb-3">Danh Sách Các Giảng Viên</h3>
                {listProfile && listProfile.map((profile) => {
                    return (<div className="col-12 col-sm-2 profile-item" key={profile.id}>
                        <div className="wrapper border shadow" onClick={() => {
                            setModalInfo(profile)
                            setShow(true)
                        }}>
                            <div className="w-100 d-flex justify-content-center p-3">
                                <div className="avatar-group">
                                    <img src={profile.avatar ? profile.avatar : men_teacher} alt="" className="" />
                                </div>
                            </div>
                            <div className="w-100 p-3 pt-0">
                                <h5 className="w-100 text-center">{profile.fullname}</h5>
                                <p className="w-100 text-center mt-2">{profile.chucvu}</p>
                                <p className="w-100 text-center"><strong>{profile.part_title}</strong></p>
                                <p className="w-100 text-center"><strong>{profile.company}</strong></p>
                            </div>
                        </div>
                    </div>)
                })}
            </div>
        </div>
        <Modal show={show} onHide={() => {
            setShow(false)
            setModalInfo(null)
        }} animation={true} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Thông tin giảng viên</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="w-100 modal-profile">
                    {modalInfo &&
                        <div className="row">
                            <div className="col-12 col-sm-4">
                                <img src={modalInfo.avatar ? modalInfo.avatar : men_teacher} alt="" className="avatar" />
                            </div>
                            <div className="col-12 col-sm-8">
                                <h4 className="mb-3 mt-2">Họ và tên: {modalInfo.fullname}</h4>
                                <p>Chức danh: {modalInfo.chucvu}</p>
                                <p>Phòng ban: {modalInfo.part_title}</p>
                                <p>Công ty: {modalInfo.company}</p>
                                <p>Liên hệ: {modalInfo.email}</p>
                                <p>Sinh nhật: <Moment format="DD/MM/YYYY">{modalInfo.birthday}</Moment></p>
                                <p>{modalInfo.marital_status && modalInfo.marital_status != "Độc thân" ? modalInfo.marital_status : "Hiện vẫn đang độc thân"}</p>
                            </div>
                            <div className="col-12 mt-2">
                                <div className="w-100 mt-2 post-content" dangerouslySetInnerHTML={{ __html: linkify(modalInfo.description) }} />
                            </div>
                        </div>
                    }
                </div>
            </Modal.Body>
        </Modal>
    </AkkhorLayout>);
}
